/**
 *
 * @export
 * @enum {string}
 */
export enum DialogTracking {
	NONE = "NONE",
	// Drafts
	REMOVE_DRAFT = "REMOVE_DRAFT",
	// Templates
	REMOVE_TEMPLATE = "REMOVE_TEMPLATE",
	// Leave Order Flow
	LEAVE_TRUCK = "LEAVE_TRUCK",
	// New Order
	BUILD_ORDER_OPTIONS = "BUILD_ORDER_OPTIONS",
	CANCEL_ORDER = "CANCEL_ORDER",
	CUSTOM_COLOR_ENTRY = "CUSTOM_COLOR_ENTRY",
	CSV_UPLOAD = "CSV_UPLOAD",
	MANUAL_ORDER_ENTRY = "MANUAL_ORDER_ENTRY",
	SELECT_BILLTO_ACCOUNT = "SELECT_BILLTO_ACCOUNT",
	SELECT_CUSTOM_COLOR = "SELECT_CUSTOM_COLOR",
	// Trucks
	ADD_TRUCK_ORDER = "ADD_TRUCK_ORDER",
	ADD_TRUCK_STOP = "ADD_TRUCK_STOP",
	DELETE_TRUCK = "DELETE_TRUCK",
	REMOVE_TRUCK_STOP = "REMOVE_TRUCK_STOP",
	REMOVE_TRUCK_ORDER = "REMOVE_TRUCK_ORDER",
	// Custom Quote
	CUSTOM_QUOTE_ADD_GLOBALS = "CUSTOM_QUOTE_ADD_GLOBALS",
	REMOVE_CUSTOM_QUOTE = "REMOVE_CUSTOM_QUOTE",
	DECLINE_CUSTOM_QUOTE = "DECLINE_CUSTOM_QUOTE",
	LEAVE_ADD_CUSTOM_QUOTE = "LEAVE_ADD_CUSTOM_QUOTE",
	LEAVE_CREATE_CUSTOM_QUOTE = "LEAVE_CREATE_CUSTOM_QUOTE",
	DELETE_CUSTOM_QUOTE_REVISION = "DELETE_CUSTOM_QUOTE_REVISION",
	// Lead Assignment
	DECLINE_LEAD = "DECLINE_LEAD"
}
